import Icon from '../components/Icon.vue'

Icon.register({"indent":{"width":448,"height":512,"paths":[{"d":"M0 84V44C0 35.2 7.2 28 16 28H432C440.8 28 448 35.2 448 44V84C448 92.8 440.8 100 432 100H16C7.2 100 0 92.8 0 84zM176 228H432C440.8 228 448 220.8 448 212V172C448 163.2 440.8 156 432 156H176C167.2 156 160 163.2 160 172V212C160 220.8 167.2 228 176 228zM16 484H432C440.8 484 448 476.8 448 468V428C448 419.2 440.8 412 432 412H16C7.2 412 0 419.2 0 428V468C0 476.8 7.2 484 16 484zM176 356H432C440.8 356 448 348.8 448 340V300C448 291.2 440.8 284 432 284H176C167.2 284 160 291.2 160 300V340C160 348.8 167.2 356 176 356zM123.3 244.7L27.3 148.7C17.3 138.7 0 145.8 0 160V352C0 366.3 17.3 373.3 27.3 363.3L123.3 267.3C129.6 261.1 129.6 250.9 123.3 244.7z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/indent.js
// module id = OQxr
// module chunks = 0